/** @jsxImportSource @emotion/react */
'use client'

import Typography from '@mui/material/Typography'
import { FlexCol, FlexRow } from '../layout'
import StatCardShell from './StatCardShell'
import { styles } from './styles'

/**
 * Compliance stat — every output logged and traceable to FCA / GDPR standards,
 * UK & EU based. The focal "value" is the row of standards pills.
 */
export default function ComplianceStatCard() {
  return (
    <StatCardShell
      kicker="Traceable by design"
      tone="mint"
      footer={
        <Typography component="p" css={[styles.metricLabel]}>
          Every output logged and traceable, so it stands up to regulatory
          scrutiny.
        </Typography>
      }
    >
      <FlexRow gap="sm" css={styles.pillRow}>
        <span css={styles.pillSolid}>FCA</span>
        <span css={styles.pillSolid}>GDPR</span>
        <span css={styles.pillOutline}>UK &amp; EU</span>
      </FlexRow>
    </StatCardShell>
  )
}
